export default __webpack_public_path__ + "static/media/grip-horizontal-solid.e407148f.svg";